import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Divider, Typography } from '@mui/material';
import { t } from 'i18next';

import Logo from '~/assets/icons/sidebar-logo-new.svg?react';
import { PATH } from '~/constants/route-path';
import { useAppDispatch } from '~/hooks/useRedux';
import { qrCodeSlice } from '~/store/reducers/qr-code';
import { COLORS } from '~/styles/colors';

export default function AuthTemplate({
  h1,
  h2,
  h3,
  topBody,
  bottomBody,
  alertNode,
  autoHeight,
  customProps,
  showPrivacyPolicyText,
}) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const handleOpenInNewWindow = () => {
    window.open(PATH.TOS, '_blank');
  };

  useEffect(() => {
    if (location.pathname === PATH.LOGIN) dispatch(qrCodeSlice.actions.setSelectedQr(null));
  }, [location.pathname]);

  return (
    <Box
      className="auth"
      sx={{
        borderRadius: 1,
        backgroundColor: COLORS.white,
        padding: customProps?.containerPadding || 2,
        height: autoHeight ? 'auto' : '100vh',
      }}
    >
      {alertNode}
      <Box width="100%" maxWidth="530px">
        {!customProps?.hideLogo && (
          <Box textAlign="center" mb="45px">
            <Logo cursor="pointer" onClick={() => navigate(PATH.UNAUTH.MAIN)} />
          </Box>
        )}
        <Typography textAlign="center" fontSize={customProps?.f_h1 || 42}>
          {h1}
        </Typography>
        <Typography width={customProps?.full_h2 ? '100%' : '95%'} textAlign="center" color={COLORS.black06}>
          {h2} <br /> {h3}
        </Typography>
        {topBody}
        <Divider sx={{ margin: '1.5rem 0' }} />
        {bottomBody}
        {showPrivacyPolicyText && (
          <Box sx={{ textAlign: 'center', color: COLORS.black04, mt: 3 }}>
            <Typography sx={{ fontSize: 12 }}>{t('login:bottomTitle')}</Typography>
            <Typography sx={{ fontSize: 12 }}>
              {`${t('login:bottomTitle1')} `}
              <span
                onClick={handleOpenInNewWindow}
                style={{ color: COLORS.purple, textDecoration: 'underline', cursor: 'pointer' }}
              >
                {t('login:bottomTitle2')}
              </span>
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
